"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzCard = _interopRequireDefault(require("./../OzCard/OzCard.js"));

var _OzIcon = _interopRequireDefault(require("./../OzIcon/OzIcon.js"));

var _OzButton = _interopRequireDefault(require("./../OzButton/OzButton.js"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__Wrapper",
  componentId: "sc-1p2htku-0"
})(["\n  text-align: center;\n  line-height: 18px;\n"]);

var Name = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__Name",
  componentId: "sc-1p2htku-1"
})(["\n  color: ", ";\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 45px;\n  text-transform: uppercase;\n"], _consts.CHETWODEBLUE);

var Price = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__Price",
  componentId: "sc-1p2htku-2"
})(["\n  font-weight: 600;\n  font-size: 35px;\n  line-height: 30px;\n"]);

var Title = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__Title",
  componentId: "sc-1p2htku-3"
})(["\n  font-weight: 700;\n  font-size: 12px;\n  margin-bottom: 6px;\n"]);

var Text = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__Text",
  componentId: "sc-1p2htku-4"
})(["\n  font-size: 12px;\n  margin-bottom: 3px;\n"]);

var BgBlock = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__BgBlock",
  componentId: "sc-1p2htku-5"
})(["\n  border-radius: 9px;\n  background: ", "13;\n  margin: 15px 0px 10px;\n  padding: 20px 20px;\n"], _consts.CHETWODEBLUE);

var Block = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__Block",
  componentId: "sc-1p2htku-6"
})(["\n  margin: 0px;\n  padding: 10px 0px 10px;\n  border-bottom: 2px dashed ", ";\n"], _consts.WHITESMOKE);

var CtaBlock = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__CtaBlock",
  componentId: "sc-1p2htku-7"
})(["\n  margin: 0px;\n  padding: 30px 0px 0px;\n"]);

var TextIcon = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__TextIcon",
  componentId: "sc-1p2htku-8"
})(["\n  display: inline-block;\n  position: relative;\n  bottom: -2px;\n  margin-right: 2px;\n"]);

var Value = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__Value",
  componentId: "sc-1p2htku-9"
})(["\n  font-size: 17px;\n  font-weight: 600;\n\n  & small{\n    font-size: 12px;\n    font-weight: normal;\n  }\n"]);

var ValueHighlight = _styledComponents.default.span.withConfig({
  displayName: "OzPlanCard__ValueHighlight",
  componentId: "sc-1p2htku-10"
})(["\n  color: ", ";\n"], _consts.SILVERTREE);

var Restore = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__Restore",
  componentId: "sc-1p2htku-11"
})(["\n  font-size: 10px;\n  padding-top: 10px;\n  line-height: 13px;\n"]);

var Credits = _styledComponents.default.div.withConfig({
  displayName: "OzPlanCard__Credits",
  componentId: "sc-1p2htku-12"
})(["\n  color: ", ";\n  font-size: 20px;\n  font-weight: 700;\n"], _consts.CHETWODEBLUE);

var OzPlanCard = function OzPlanCard(_ref) {
  var _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "en" : _ref$lang,
      name = _ref.name,
      price = _ref.price,
      credits = _ref.credits,
      creditSingleCost = _ref.creditSingleCost,
      rechargeCredits = _ref.rechargeCredits,
      rechargeCost = _ref.rechargeCost,
      maxHotfolders = _ref.maxHotfolders,
      maxProjects = _ref.maxProjects,
      _ref$restore = _ref.restore,
      restore = _ref$restore === void 0 ? null : _ref$restore,
      cta = _ref.cta,
      _ref$ctaDisabled = _ref.ctaDisabled,
      ctaDisabled = _ref$ctaDisabled === void 0 ? false : _ref$ctaDisabled,
      onClick = _ref.onClick;
  return __jsx(Wrapper, null, __jsx(_OzCard.default, null, __jsx(Name, null, name), __jsx(Price, null, "\u20AC ", price), __jsx(Text, null, lang === "it" ? "Mese" : "Month"), __jsx(BgBlock, null, __jsx(Title, null, lang === "it" ? "Crediti inclusi" : "Included credits"), __jsx(Credits, null, credits), __jsx(Restore, null, restore ? __jsx(_react.default.Fragment, null, lang === "it" ? __jsx(_react.default.Fragment, null, "Recupero dei crediti inutilizzati ", __jsx("b", null, "fino a un massimo di ", restore)) : __jsx(_react.default.Fragment, null, "Return of unused credits ", __jsx("b", null, "up to a max of ", restore))) : __jsx(_react.default.Fragment, null, lang === "it" ? "I crediti non utilizzati nel periodo non verranno recuperati" : "Credit not used in the period will not be recovered"))), __jsx(Block, null, __jsx(Text, null, lang === "it" ? "Costo singolo credito" : "Single credit cost"), __jsx(Value, null, "\u20AC ", creditSingleCost)), __jsx(Block, null, __jsx(Text, null, lang === "it" ? "Crediti aggiuntivi" : "Additional Credits"), __jsx(Value, null, __jsx(ValueHighlight, null, rechargeCredits), " ", __jsx("small", null, lang === "it" ? "a" : "for"), " \u20AC ", rechargeCost)), __jsx(Block, null, __jsx(Text, null, __jsx(TextIcon, null, __jsx(_OzIcon.default, {
    name: "hotfolder",
    color: "#000000",
    size: "15px"
  })), " ", lang === "it" ? __jsx(_react.default.Fragment, null, maxHotfolders !== null ? __jsx(_react.default.Fragment, null, __jsx("b", null, maxHotfolders), " ", maxHotfolders === 1 ? "Hotfolder" : "Hotfolders") : __jsx(_react.default.Fragment, null, "Hotfolders ", __jsx("b", null, "illimitate"), " ")) : __jsx(_react.default.Fragment, null, __jsx("b", null, maxHotfolders !== null ? maxHotfolders : "Unlimited"), " ", maxHotfolders === 1 ? "Hotfolder" : "Hotfolders"))), __jsx(Block, null, __jsx(Text, null, __jsx(TextIcon, null, __jsx(_OzIcon.default, {
    name: "project",
    color: "#000000",
    size: "15px"
  })), " ", __jsx("b", null, maxProjects !== null ? maxProjects : "Unlimited"), " ", maxProjects === 1 ? "Project" : "Projects")), cta && onClick ? __jsx(CtaBlock, null, ctaDisabled ? __jsx(_OzButton.default, {
    variant: "disabled",
    disabled: true
  }, cta) : __jsx(_OzButton.default, {
    variant: "chetwodeblue",
    onClick: onClick
  }, cta)) : null));
};

var _default = OzPlanCard;
exports.default = _default;